// Vendors
import $ from 'jquery';

$('.team-member-card').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  infinite: true,
  fade: true,
  asNavFor: '.team-member-slider',
  nextArrow:
    '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><i class="fa fa-arrow-right"></i></button>',
  prevArrow:
    '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i class="fa fa-arrow-left"></i></button>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        adaptiveHeight: true,
      }
    }
  ]
});

$('.team-member-slider').slick({
  slidesToScroll: 1,
  asNavFor: '.team-member-card',
  dots: false,
  centerMode: false,
  focusOnSelect: true,
  infinite: false
});
